import { render, staticRenderFns } from "./IviPayMobile.vue?vue&type=template&id=0350de21&"
import script from "./IviPayMobile.vue?vue&type=script&lang=js&"
export * from "./IviPayMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports